<template>
  <ToastModal
    ref="modal"
    :title="$t('LandingsPage.Women.Every3MonthsFreeTop.Title')"
    show-mobile-footer
    :width="814"
    modal-id="HowItWorksModal"
  >
    <WomenHowItWorks
      :title="title"
      :description="description"
      :atc-text="atcText"
      :how-it-works-slides="howItWorksSlides"
    />
    <template v-slot:footer>
      <ToastModalFooter class="w-full md:w-auto" variant="outline" color="black" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import WomenHowItWorks from '@/components/Women/HowItWorks'
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'

export default {
  name: 'WomenHowItWorksModal',
  components: { WomenHowItWorks, ToastModal, ToastModalFooter },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    atcText: {
      type: String,
      default: ''
    },
    howItWorksSlides: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    toggleActivation () {
      this.$refs.modal.toggleActivation()
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>

<style lang="postcss" scoped>
>>> {
  .toast-modal-content-box, .vm--modal {
    @apply bg-women-shade;
  }
}
</style>
